import React, { FC, useState } from "react";
import { ObjectToClassString } from "../../utils/functions";

import "./Button.scss";
import { useTranslation } from "react-i18next";

interface IButton {
  color?: "primary" | "secondary" | "tertiary";
  iconPosition?: "left" | "right";
  tooltipMessage?: string;
  stopPropagation?: boolean;
  active?: boolean;
  outline?: boolean;
  outlineSmall?: boolean;
  disabled?: boolean;
  circle?: boolean;
  onlyIcon?: boolean;
  onlyIconMedium?: boolean;
  onlyIconSmall?: boolean;
  text?: boolean;
  textSmall?: boolean;
  textWithIcon?: boolean;
  btnWithoutText?: boolean;
  medium?: boolean;
  fullWidth?: boolean;
  clear?: boolean;
  fabOutline?: boolean;
  onClick?: () => void;
  btnType?: "submit" | "button";
  icon?: string;
  children?: React.ReactNode;
  margin?: number;
  noHover?: boolean;
  noBorder?: boolean;
  className?: string;
  noPadding?: boolean;
  emptyButton?: boolean;
}

const Button: FC<IButton> = ({
  color = "primary",
  iconPosition = "left",
  tooltipMessage,
  stopPropagation,
  active,
  outline,
  outlineSmall,
  disabled,
  circle,
  onlyIcon,
  onlyIconMedium,
  onlyIconSmall,
  icon,
  text,
  textSmall,
  textWithIcon,
  btnWithoutText,
  medium,
  fullWidth,
  clear,
  fabOutline,
  onClick,
  btnType = "button",
  children,
  margin,
  noHover,
  noBorder,
  noPadding,
  emptyButton,
  className = "",
}) => {
  const getIconClass = (): string => {
    return "icon " + icon;
  };
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    onClick && onClick();
  };

  return (
    <>
      {handleClick ? (
        <button
          type={btnType}
          disabled={Boolean(disabled)}
          onClick={handleClick}
          className={` ${ObjectToClassString({
            outline,
            "outline-small": outlineSmall,
            [`bt-${color}`]: true,
            "btn-circle": circle,
            "btn-icon": onlyIcon,
            "btn-icon-medium": onlyIconMedium,
            "btn-icon-small": onlyIconSmall,
            "btn-text": text,
            "btn-text-small": textSmall,
            "btn-text-with-icon": textWithIcon,
            "btn-without-text": btnWithoutText,
            clear,
            "fab-outline": fabOutline,
            medium,
            "full-width": fullWidth,
            active,
            "no-hover": noHover,
            "no-border": noBorder,
            "no-padding": noPadding,
          })} position-icon-${iconPosition} m-${margin} btn-custom ${className}`}
          // (click)="buttonClick($event)"
        >
          {/* ${!disabled ? `bg-${color}` : ''}  */}
          {icon && <i className={`${getIconClass()} element-icon`}></i>}
          {typeof children === "string" ? t(children) : children}
        </button>
      ) : (
        <button
          type={btnType}
          disabled={Boolean(disabled)}
          className={` ${ObjectToClassString({
            outline,
            "outline-small": outlineSmall,
            [`bt-${color}`]: true,
            "btn-circle": circle,
            "btn-icon": onlyIcon,
            "btn-icon-medium": onlyIconMedium,
            "btn-icon-small": onlyIconSmall,
            "btn-text": text,
            "btn-text-small": textSmall,
            "btn-text-with-icon": textWithIcon,
            "btn-without-text": btnWithoutText,
            clear,
            "fab-outline": fabOutline,
            medium,
            "full-width": fullWidth,
            active,
            "no-hover": noHover,
            "no-border": noBorder,
            "no-padding": noPadding,
          })} position-icon-${iconPosition} m-${margin} btn-custom ${className}`}
          // (click)="buttonClick($event)"
        >
          {/* ${!disabled ? `bg-${color}` : ''}  */}
          {icon && <i className={`${getIconClass()} element-icon`}></i>}
          {typeof children === "string" ? t(children) : children}
        </button>
      )}
    </>
  );
};

export default Button;
